import CornerstoneLogo from '@/assets/logos/CornerstoneLogo';
import { HEADER_HEIGHT } from '@/components/LayoutTools/Header';
import useGet from '@/utils/hooks/api/vercel/useGet';
import useSession from '@/utils/hooks/useSession';

import Image from 'next/image';
import React, { useMemo } from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  logoWrapper: {
    margin: '8px',
    height: HEADER_HEIGHT - 5,
  },
  logoWrapperV2: {
    margin: '8px',
    height: HEADER_HEIGHT - 5,
  },
}));

// Helper to determine if the logo is default
function isDefaultLogo(logo) {
  if (!logo) return true;
  const oldDefault =
    process.env.NEXT_PUBLIC_STATIC_ASSETS_URL + 'cis-logo-color.png';
  const newDefault = '/images/CornerstoneLogoColor.png';
  return [oldDefault, newDefault].includes(logo);
}

function Logo() {
  const { classes } = useStyles();
  const { org, isMinimalTemplate } = useSession();

  // Memoize to avoid recalculating on every render
  const isDefault = useMemo(() => isDefaultLogo(org.logo), [org.logo]);
  const logoS3Key = !isDefault ? org.logo : null;

  const { data: orgLogo } = useGet(`/assets/${logoS3Key}`, {
    fireOnMount: !!logoS3Key,
    skip: !logoS3Key,
  });

  if (!isDefault && orgLogo) {
    return (
      <Image
        className={
          isMinimalTemplate ? classes.logoWrapperV2 : classes.logoWrapper
        }
        width={210}
        height={HEADER_HEIGHT - 16}
        src={orgLogo?.url}
        alt='Site Logo'
        style={{
          objectFit: 'contain',
          objectPosition: 'left',
          marginLeft: 14,
        }}
        priority
      />
    );
  }

  return (
    <CornerstoneLogo
      className={
        isMinimalTemplate ? classes.logoWrapperV2 : classes.logoWrapper
      }
      colors={{
        primary: '#040059',
        secondary: '#ff8806',
        tertiary: '#4f88fc',
      }}
    />
  );
}

export default Logo;
